module.exports = __webpack_public_path__ + "static/media/HS5099HJ.85833953.jpg";